class Header {
    constructor() {
        this.isPc = window.matchMedia("(min-width: 992px)").matches;
        this.headerIsFixed = false;
        this.header = document.getElementById('ftsHeader');
        this.headerBar = document.getElementById('ftsHeaderBar');
        this.body = document.body;

        if(this.header && this.headerBar) {
            if(!this.header.classList.contains('fts-header--always-fixed')) {
                this.addTopPadding();
                this.event();
            }
        }
        
    }

    // ============
    // Events
    // =============
    event() {
        // スクロールの時の処理
        window.addEventListener('scroll', () => this.heandleHeader());

        // リサイズの時の処理
        window.addEventListener('resize', () => {
            this.isPc = window.matchMedia("(min-width: 992px)").matches;
            this.addTopPadding()
        })
    }

    heandleHeader() {
        this.handleHeaderPosition();
        this.addTopPadding();


        if(this.isPc && window.scrollY > 400) {
            this.headerIsFixed = true;
        }else {
            this.headerIsFixed = false;
        }
    }

    // ============
    // Methods
    // =============

    // ヘッダーの固定/非固定の処理
    handleHeaderPosition() {
        if(this.headerIsFixed) {
            this.header.style.position = 'fixed';
            this.headerBar.classList.add('is-fixed');
        }else {
            this.header.style.position = '';
            this.headerBar.classList.remove('is-fixed')
        }
    }

    // ページ最上部のパディングの処理
    addTopPadding() {
        if(this.headerIsFixed) {
            this.body.style.paddingTop = `${this.header.clientHeight}px`;
        }else {
            if(this.isPc) {
                this.body.style.paddingTop = '';
            }else {
                this.body.style.paddingTop = `${this.header.clientHeight}px`
            }
        }

    }
}

export default Header;